import { render, staticRenderFns } from "./ConfirmRemoveMfaDialog.vue?vue&type=template&id=0b40fed6&"
import script from "./ConfirmRemoveMfaDialog.ts?vue&type=script&lang=ts&"
export * from "./ConfirmRemoveMfaDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports